import SecuritiescompanyContainer from "src/container/securitiescompany";
import { Helmet } from "react-helmet-async";

const Securitiescompany = () => {
  return (
    <>
      <Helmet>
        <title>텔레모아::핵심 텔레그램 채널의 중요 정보를 모아!</title>
        <meta name="description" content="증권사에서 바라보는 증시 인사이트, 수준이 다른 투자 정보를 텔레모아에서 확인!" />
      </Helmet>
      <div className="container mt-4">
        <div className="row">
          <div className="px-3 py-4 col-12 col-lg-12">
            <SecuritiescompanyContainer rowPerPage={20} />
          </div>  
        </div>
      </div>
    </>
  );
}

export default Securitiescompany;
